import { Typography } from '@bowtie-ins/bowkit';
import { BOWTIE_BLUE, WHITE } from '@bowtie-ins/bowkit/palette';
import { Promotion, useDateCountdown } from '@bowtie-web/common';
import { Link, Markdown, MarkdownOverrides } from '@bowtie-web/components';
import { Box, Collapse } from '@material-ui/core';
import dayjs from 'dayjs';
import { useMemo } from 'react';
import Counter from './Counter';

const CUSTOM_COMPONENTS: MarkdownOverrides = {
  p: ({ children }) => (
    <span style={{ margin: 0, whiteSpace: 'pre-line', color: 'inherit' }}>
      {children}
    </span>
  ),
  a: props => (
    <Link
      {...props}
      target="_blank"
      rel="noreferrer noopener"
      component="a"
      style={{
        color: 'inherit',
        fontSize: 'inherit',
        lineHeight: 'inherit',
        fontWeight: 'inherit',
        textDecorationLine: 'underline',
      }}
      underline="none"
    />
  ),
};

type PromotionBannerProps = {
  promotion?: Promotion;
  collapse?: boolean;
  size: 'small' | 'large';
};

const PromotionBanner = ({
  promotion,
  collapse = false,
  size,
}: PromotionBannerProps) => {
  const effectiveDateTime = useMemo(
    () => dayjs(promotion?.display_effective_to).add(1, 'd'),
    [promotion?.display_effective_to],
  );

  const countdownUnits = useDateCountdown(effectiveDateTime);

  return (
    <Collapse
      in={!!promotion && !collapse}
      timeout={600}
      style={{ marginBottom: !promotion || collapse ? 0 : 16 }}
    >
      <Box
        borderRadius="8px"
        minHeight={size === 'small' ? 70 : 50}
        bgcolor={BOWTIE_BLUE}
        display="flex"
        flexDirection={size === 'small' ? 'column' : 'row'}
        color={WHITE}
        alignItems="center"
        justifyContent={size === 'small' ? 'space-around' : 'space-between'}
        padding="12px 20px"
        gridGap={8}
      >
        <Typography
          variant="title-xs"
          style={{ textAlign: size === 'small' ? 'center' : 'start' }}
        >
          {promotion?.banner_name && (
            <Box
              component="span"
              bgcolor="#ee9f00"
              borderRadius={4}
              p={0.5}
              mr={1}
            >
              {promotion.banner_name}
            </Box>
          )}
          <Markdown options={{ overrides: CUSTOM_COMPONENTS }}>
            {promotion?.banner_message || promotion?.message || ''}
          </Markdown>
        </Typography>
        <Counter {...countdownUnits} />
      </Box>
    </Collapse>
  );
};

export default PromotionBanner;
